import React from 'react';
// import logo from './../img/lr-logo.svg';
import logo from 'custom/img/logo-dark.svg';
import styles from 'custom/layout.styl';

export default (props) => {
  return (
    <div className={styles.container}>
      <header className={styles.light_header}>
        <img src={logo} className={styles.logo} alt="logo" />
      </header>
    </div>
  );
};



// WEBPACK FOOTER //
// ./src/components/Header.js